define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/page"
], function(declare,EditController,page) {

	return declare(EditController, {
		postProcessSuccess: function() {
			page.refreshRootView();
		}
	});
});